/* @sravni/react-design-system version 0.2.55 */
var css = "._1rje6us {\n  color: var(--color-D60);\n  font-size: 12px;\n  line-height: 16px;\n}\n._1m0eq57 {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n";
var modules_3fa78883 = {"container":"_1rje6us","item":"_1m0eq57"};
import "../../../assets/components/Breadcrumb/styles/Breadcrumb.module.less-fa68fc44.css";

export default modules_3fa78883;
export { css };
